module.exports = __webpack_public_path__ + "img/rifle.bolt.8b03e33f.png";